// import React, { useState } from "react";
// import { BuildingImg } from "../assets/images";
// import AuthImages from "../components/AuthImages";

// const ResetPassword = () => {
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//   return (
//     <div className="auth-page">
//       <div className="auth-row d-flex w-100">
//         <AuthImages />
//         <div className="auth-login-box">
//           <div className="auth-form d-flex flex-column justify-content-center mx-auto">
//             <div className="auth-form-title">
//               <div className="icon">
//                 <img src={BuildingImg} alt="Building" />
//               </div>
//               <h2>Reset Password</h2>
//               <p>
//                 No worries! Enter your email address and we'll send you a
//                 verification link to reset your password.
//               </p>
//             </div>
//             <form>
//               {/* New Password */}
//               <div className="form-group">
//                 <label>Enter New Password</label>
//                 <div className="password-input">
//                   <input
//                     type={showNewPassword ? "text" : "password"}
//                     className="form-control"
//                     placeholder="Enter your password"
//                   />
//                   <span
//                     className="icon-btn cursor-pointer"
//                     onClick={() => setShowNewPassword(!showNewPassword)}
//                   >
//                     <i
//                       className={showNewPassword ? "icon-icon-2" : "icon-icon-1"}
//                     ></i>
//                   </span>
//                 </div>
//               </div>

//               {/* Confirm Password */}
//               <div className="form-group">
//                 <label>Confirm Password</label>
//                 <div className="password-input">
//                   <input
//                     type={showConfirmPassword ? "text" : "password"}
//                     className="form-control"
//                     placeholder="Enter your password"
//                   />
//                   <span
//                     className="icon-btn cursor-pointer"
//                     onClick={() =>
//                       setShowConfirmPassword(!showConfirmPassword)
//                     }
//                   >
//                     <i
//                       className={
//                         showConfirmPassword ? "icon-icon-2" : "icon-icon-1"
//                       }
//                     ></i>
//                   </span>
//                 </div>
//               </div>

//               <button type="submit" className="btns">
//                 Reset Password
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ResetPassword;

import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BuildingImg } from "../assets/images";
import AuthImages from "../components/AuthImages";

const ResetPassword = () => {
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { token: forgot_token } = useParams();

  // ✅ Validation schema
  const validationSchema = Yup.object({
    new_password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("New password is required"),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("new_password"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  // ✅ Formik setup
  const formik = useFormik({
    initialValues: {
      new_password: "",
      confirm_password: "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setError("");
      setMessage("");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}auth/reset_password`,
          {
            forgot_token,
            new_password: values.new_password,
            confirm_password: values.confirm_password,
          },
          { headers: { "Content-Type": "application/json", "api-key": process.env.REACT_APP_API_KEY } }
        );

        const { status, data } = response;
        if (status === 200 && data?.status === "success") {
          setMessage("Password has been reset successfully.");
          resetForm();
          setTimeout(() => navigate("/login"), 2000); // redirect to login
        } else {
          setError(data?.message?.keyword || "Something went wrong.");
        }
      } catch (err) {
        setError(
          err.response?.data?.message?.keyword || "Something went wrong."
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="auth-page">
      <div className="auth-row d-flex w-100">
        <AuthImages />
        <div className="auth-login-box">
          <div className="auth-form d-flex flex-column justify-content-center mx-auto">
            <div className="auth-form-title">
              <div className="icon">
                <img src={BuildingImg} alt="Building" />
              </div>
              <h2>Reset Password</h2>
              <p>Enter a new password below to reset your account.</p>
            </div>
            <form onSubmit={formik.handleSubmit}>
              {/* New Password */}
              <div className="form-group">
                <label>Enter New Password</label>
                <div className="password-input">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    name="new_password"
                    className={`form-control ${
                      formik.touched.new_password &&
                      formik.errors.new_password
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder="Enter new password"
                    value={formik.values.new_password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <span
                    className="icon-btn cursor-pointer"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    <i
                      className={showNewPassword ? "icon-icon-2" : "icon-icon-1"}
                    ></i>
                  </span>
                </div>
                {formik.touched.new_password && formik.errors.new_password && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.new_password}
                  </div>
                )}
              </div>

              {/* Confirm Password */}
              <div className="form-group">
                <label>Confirm Password</label>
                <div className="password-input">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirm_password"
                    className={`form-control ${
                      formik.touched.confirm_password &&
                      formik.errors.confirm_password
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder="Confirm password"
                    value={formik.values.confirm_password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <span
                    className="icon-btn cursor-pointer"
                    onClick={() =>
                      setShowConfirmPassword(!showConfirmPassword)
                    }
                  >
                    <i
                      className={
                        showConfirmPassword ? "icon-icon-2" : "icon-icon-1"
                      }
                    ></i>
                  </span>
                </div>
                {formik.touched.confirm_password &&
                  formik.errors.confirm_password && (
                    <div className="invalid-feedback d-block">
                      {formik.errors.confirm_password}
                    </div>
                  )}
              </div>

              {/* Messages */}
              {error && <p className="text-danger">{error}</p>}
              {message && <p className="text-success">{message}</p>}

              <button
                type="submit"
                className="btns"
                disabled={formik.isSubmitting}
              >
                {formik.isSubmitting ? "Processing..." : "Reset Password"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
